// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__NcLO2","selected":"Chip_selected__21GZE"};